<ng-container
  *ngIf="{
    selectedConfig: stateService.selectedConfiguration$ | async,
    isLoadingFromService: loaderService.isLoading$ | async
  } as context">

  <div [ngClass]="featureClass">
    <!-- Chat input field: begin -->
    <mat-form-field
      *ngIf="featureClass === 'chatbot-feature'"
      appearance="outline"
      class="mt-2">
      <mat-label>{{ 'query.label' | translate }}</mat-label>
      <textarea
        (keydown)="onKeyDown($event)"
        cdkTextareaAutosize
        matInput
        rows="1"
        [formControl]="query"></textarea>
      <div class="button-container">
        <button
          mat-flat-button
          class="button-chatting"
          [disabled]="
            context.isLoadingFromService ||
            isLoading ||
            query.value?.trim() === ''
          "
          (click)="emitQuery()">
          {{ 'query.cta' | translate }}
          <img [src]="'../assets/images/icon-send.svg'" alt="Send" />
        </button>
      </div>
    </mat-form-field>
    <!-- Chat input field: end -->
  </div>
</ng-container>
